<div class="terms">
  <div class="container">
    <p>
      TBD
    </p>
  </div>
</div>